import React from 'react';
import Styles from './ModalRemoveInsurance.css';
import ModalComponent from '../../../../components/atoms/ModalComponent';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';

function ModalRemoveInsurance({ onRemove }) {
  const { modalRemoveInsurance, setModalRemoveInsurance, updateInsurance, loading } =
    useSimuladorEnergiaSolarState();

  const handleRemove = async () => {
    await updateInsurance(false);

    if (onRemove) {
      onRemove();
    }
  };

  return (
    <>
      <ModalComponent
        open={modalRemoveInsurance}
        hideCloseButton
        id="modal-remove-insurance"
        allowSurfaceScroll={false}
        setOpen={setModalRemoveInsurance}
      >
        <h6 className="text-title">Deseja remover o Proteção financeira?</h6>
        <p className="text-desc">
          Com este seguro, você conta com proteção para desemprego involuntário, invalidez
          permanente total por acidente e invalidez física temporária por acidente.
        </p>

        <div className="btns">
          <Button variant="red" id="btn-remove-insurance" onClick={handleRemove} disabled={loading}>
            Remover
          </Button>
          <Button
            disabled={loading}
            variant="white"
            onClick={() => {
              setModalRemoveInsurance(false);
            }}
          >
            Voltar
          </Button>
        </div>
      </ModalComponent>
      <style jsx>{Styles}</style>
    </>
  );
}

export default ModalRemoveInsurance;
